const COMPANY = 'Krit Cloud Platforms Sdn Bhd';
const LOCATION = 'Malaysia';

const industries = ['Healthcare', 'Logistics', 'Manufacturing', 'Retail', 'Finance', 'Education', 'Government', 'SMEs', 'Startups'];

const defaultRelated = [
    { label: 'IT Consulting & Digital Transformation', slug: 'IT-Consulting-and-Digital-Transformation' },
    { label: 'Cloud & Infrastructure Services', slug: 'Cloud-and-Infrastructure-Services' },
    { label: 'Custom Software Development', slug: 'Custom-Software-Development' },
];

const profiles = {
    'Managed-IT-Services': {
        keyword: 'managed IT services',
        focus: 'IT operations, user support, vendor coordination, asset visibility and technology planning',
        value: 'keeps business technology stable, visible and easier to manage',
        services: ['IT operations management', 'User and device support', 'Vendor and asset coordination', 'Technology roadmap planning', 'Security coordination', 'Service improvement reviews'],
        benefits: ['Improved system reliability', 'Faster support response', 'Clearer asset visibility', 'Better vendor coordination', 'Reduced operational risk', 'Scalable IT planning'],
        process: ['Review current IT operations', 'Identify support and governance gaps', 'Define service priorities', 'Improve support routines', 'Track service quality'],
        technologies: ['Microsoft 365', 'Windows Server', 'Azure', 'AWS', 'SQL Server', 'Power BI'],
        related: ['Cloud-and-Infrastructure-Services', 'Cybersecurity-and-Compliance', 'Maintenance-and-Support'],
    },
    'Cloud-and-Infrastructure-Services': {
        keyword: 'cloud and infrastructure services',
        focus: 'cloud migration, infrastructure setup, backup, monitoring, recovery and cost control',
        value: 'creates a reliable foundation for applications, data and business operations',
        services: ['Cloud migration planning', 'Infrastructure setup', 'Backup and disaster recovery', 'Cloud monitoring', 'Cost optimization', 'Operational documentation'],
        benefits: ['Safer cloud adoption', 'More reliable infrastructure', 'Improved backup readiness', 'Better cost visibility', 'Stronger monitoring', 'Clearer operational ownership'],
        process: ['Assess current systems', 'Plan the target architecture', 'Configure cloud foundations', 'Validate security and recovery', 'Handover operations'],
        technologies: ['Azure', 'AWS', 'Microsoft 365', 'Docker', 'Windows Server', 'SQL Server'],
        related: ['Managed-IT-Services', 'Cybersecurity-and-Compliance', 'Maintenance-and-Support'],
    },
    'Cybersecurity-and-Compliance': {
        keyword: 'cybersecurity and compliance services',
        focus: 'security assessments, access control, cloud monitoring, compliance readiness and governance',
        value: 'reduces technology risk while improving audit and governance readiness',
        services: ['Security posture reviews', 'Identity and access management', 'Cloud security monitoring', 'Compliance planning', 'Risk reporting', 'Governance improvement'],
        benefits: ['Lower security exposure', 'Better access governance', 'Improved audit readiness', 'Clear risk priorities', 'Stronger monitoring', 'Practical compliance controls'],
        process: ['Review systems and access', 'Identify risks and control gaps', 'Prioritize remediation', 'Implement practical controls', 'Review progress regularly'],
        technologies: ['Azure Security', 'AWS Security', 'Microsoft Entra ID', 'Microsoft 365', 'SIEM Tools', 'Power BI'],
        related: ['Managed-IT-Services', 'Cloud-and-Infrastructure-Services', 'IT-Consulting-and-Digital-Transformation'],
    },
    'Custom-Software-Development': {
        keyword: 'custom software development',
        focus: 'business systems, portals, APIs, databases, SaaS products and legacy modernization',
        value: 'builds software around real workflows instead of forcing teams into unsuitable tools',
        services: ['Business application development', 'API and database integration', 'SaaS product development', 'Legacy modernization', 'Portal development', 'Testing and release support'],
        benefits: ['Better process fit', 'Reduced manual work', 'Integrated systems', 'Secure user access', 'Maintainable codebase', 'Scalable architecture'],
        process: ['Gather requirements', 'Design architecture', 'Build in focused phases', 'Test with users', 'Deploy and improve'],
        technologies: ['React.js', 'Node.js', '.NET', 'Java', 'Python', 'PostgreSQL', 'SQL Server'],
        related: ['Web-and-Mobile-App-Development', 'AI-and-Process-Automation', 'Maintenance-and-Support'],
    },
    'Web-and-Mobile-App-Development': {
        keyword: 'web and mobile app development',
        focus: 'web applications, customer portals, staff portals, Android apps, iOS apps and cross-platform products',
        value: 'delivers practical digital products for customers, staff and operations teams',
        services: ['Web application development', 'Customer and staff portals', 'Android and iOS app delivery', 'Cross-platform mobile apps', 'API integration', 'Responsive interface development'],
        benefits: ['Better customer access', 'Responsive user experience', 'Mobile-ready workflows', 'Secure app integrations', 'Improved service delivery', 'Reusable digital platforms'],
        process: ['Define users and journeys', 'Design responsive interfaces', 'Build application features', 'Integrate APIs', 'Test and launch'],
        technologies: ['React.js', 'React Native', 'Node.js', 'Swift', 'Kotlin', 'Firebase', 'REST APIs'],
        related: ['Custom-Software-Development', 'CRM-and-Business-Applications', 'Maintenance-and-Support'],
    },
    'Data-Analytics-and-Business-Intelligence': {
        keyword: 'data analytics and business intelligence',
        focus: 'dashboards, reporting, data pipelines, data warehouses, KPI tracking and analytics platforms',
        value: 'turns business data into clearer reporting and better decisions',
        services: ['Business intelligence dashboards', 'Power BI reporting', 'Data pipelines and warehouses', 'Analytics platform implementation', 'KPI modelling', 'Reporting governance'],
        benefits: ['Clearer KPI tracking', 'Trusted reporting data', 'Faster management decisions', 'Reduced spreadsheet dependency', 'Role-based dashboards', 'Improved data governance'],
        process: ['Define reporting goals', 'Review data sources', 'Model trusted datasets', 'Build dashboards', 'Improve governance'],
        technologies: ['Power BI', 'SQL Server', 'PostgreSQL', 'Databricks', 'Azure Data Services', 'Python'],
        related: ['AI-and-Process-Automation', 'CRM-and-Business-Applications', 'IT-Consulting-and-Digital-Transformation'],
    },
    'CRM-and-Business-Applications': {
        keyword: 'CRM and business application services',
        focus: 'CRM workflows, customer records, sales pipelines, service processes and business application configuration',
        value: 'helps teams manage customers, sales and internal workflows with clearer systems',
        services: ['CRM workflow design', 'Sales and service pipelines', 'Customer data structure', 'Business application configuration', 'CRM reporting', 'Follow-up automation'],
        benefits: ['Better customer visibility', 'Cleaner sales pipeline data', 'More consistent follow-ups', 'Improved team accountability', 'Useful CRM reporting', 'Reduced manual tracking'],
        process: ['Map customer lifecycle', 'Define fields and roles', 'Configure workflows', 'Automate follow-ups', 'Review adoption'],
        technologies: ['Microsoft Dynamics', 'HubSpot', 'Power BI', 'SQL Server', 'API Integration', 'Azure'],
        related: ['Data-Analytics-and-Business-Intelligence', 'AI-and-Process-Automation', 'Custom-Software-Development'],
    },
    'AI-and-Process-Automation': {
        keyword: 'AI and process automation',
        focus: 'workflow automation, AI chatbots, document processing, support automation and system integration',
        value: 'reduces repetitive work and helps teams respond faster with smarter workflows',
        services: ['Process automation planning', 'AI chatbot development', 'Document processing automation', 'Support workflow automation', 'System integration', 'Performance measurement'],
        benefits: ['Reduced manual effort', 'Faster response times', 'Fewer process errors', 'Improved document handling', 'Better support consistency', 'Measurable efficiency gains'],
        process: ['Identify repeatable work', 'Define automation rules', 'Design AI-assisted flows', 'Integrate systems', 'Measure improvement'],
        technologies: ['Azure AI', 'OpenAI APIs', 'Node.js', 'Python', 'Power Automate', 'REST APIs'],
        related: ['Data-Analytics-and-Business-Intelligence', 'CRM-and-Business-Applications', 'Custom-Software-Development'],
    },
    'IT-Consulting-and-Digital-Transformation': {
        keyword: 'IT consulting and digital transformation',
        focus: 'technology strategy, transformation roadmaps, process improvement, change planning and execution support',
        value: 'turns technology goals into practical, phased modernization programs',
        services: ['Digital transformation roadmap', 'Technology strategy', 'Business process optimization', 'Change planning', 'Solution advisory', 'Execution support'],
        benefits: ['Clearer digital roadmap', 'Better technology investment', 'Improved process efficiency', 'Aligned stakeholders', 'Reduced transformation risk', 'Practical execution plan'],
        process: ['Assess current operations', 'Identify business priorities', 'Compare technology options', 'Design roadmap', 'Support phased execution'],
        technologies: ['Azure', 'AWS', 'Microsoft 365', 'Power BI', 'React.js', 'Node.js'],
        related: ['Managed-IT-Services', 'Cloud-and-Infrastructure-Services', 'AI-and-Process-Automation'],
    },
    'Maintenance-and-Support': {
        keyword: 'maintenance and support services',
        focus: 'post-launch support, bug fixes, monitoring, enhancements, performance improvements and technical advisory',
        value: 'keeps websites, applications and cloud systems reliable after launch',
        services: ['Application maintenance', 'Bug fixing and enhancements', 'Performance monitoring', 'Post-launch technical support', 'Release support', 'Improvement planning'],
        benefits: ['Less downtime', 'Faster issue resolution', 'Improved user confidence', 'Controlled enhancement backlog', 'Better performance', 'Longer system lifespan'],
        process: ['Review support needs', 'Set service priorities', 'Monitor issues', 'Fix and deploy updates', 'Report improvements'],
        technologies: ['React.js', 'Node.js', '.NET', 'SQL Server', 'Azure', 'AWS'],
        related: ['Managed-IT-Services', 'Custom-Software-Development', 'Cloud-and-Infrastructure-Services'],
    },
};

const getProfile = (service) => profiles[service.slug] || {
    keyword: service.title.toLowerCase(),
    focus: `${service.title.toLowerCase()} planning, implementation, support and continuous improvement`,
    value: 'helps businesses modernize operations with practical technology and dependable support',
    services: service.features || service.outcomes || ['Consulting', 'Planning', 'Implementation', 'Testing', 'Support', 'Maintenance'],
    benefits: service.outcomes || ['Improved productivity', 'Better security', 'Scalable infrastructure', 'Faster deployment', 'Reduced operational cost', 'Improved customer experience'],
    process: ['Discover current needs', 'Plan a suitable solution', 'Implement in practical phases', 'Test with stakeholders', 'Support continuous improvement'],
    technologies: ['React.js', 'Node.js', 'Azure', 'AWS', 'SQL Server', 'Power BI'],
    related: defaultRelated.map((link) => link.slug),
};

const relatedFromSlugs = (slugs, allServices, currentSlug) => {
    const available = allServices.reduce((acc, service) => {
        acc[service.slug] = service;
        return acc;
    }, {});

    const links = slugs
        .filter((slug) => slug !== currentSlug && available[slug])
        .map((slug) => ({ label: available[slug].title, slug }));

    return links.length ? links : defaultRelated.filter((link) => link.slug !== currentSlug);
};

const buildFaqs = (service, profile) => [
    {
        question: `What is ${service.title}?`,
        answer: `${service.title} focuses on ${profile.focus}. ${COMPANY} shapes the work around business goals, operational needs and long-term maintainability.`,
    },
    {
        question: `Why do businesses in ${LOCATION} need ${profile.keyword}?`,
        answer: `Businesses in ${LOCATION} use ${profile.keyword} to improve productivity, reduce technology risk and build systems that are easier to scale.`,
    },
    {
        question: `How long does a ${service.title} project take?`,
        answer: 'Timeline depends on scope, integrations, data quality and approval speed. Most engagements begin with discovery so priorities, risks and delivery phases are clear before implementation.',
    },
    {
        question: `Does ${COMPANY} provide ongoing support?`,
        answer: `Yes. ${COMPANY} can provide maintenance, monitoring, enhancements and advisory support after launch so the solution continues to serve business users.`,
    },
    {
        question: `Which industries can use ${service.title}?`,
        answer: `The service can support healthcare, logistics, manufacturing, retail, finance, education, government, SMEs and startups when the solution is matched to each operating model.`,
    },
];

const buildSeoContent = (service, allServices) => {
    const profile = getProfile(service);
    const title = `${service.title} Malaysia | Krit Cloud Platforms`;
    const metaDescription = `${COMPANY} provides ${profile.keyword} in ${LOCATION} for practical IT services, cloud solutions and digital transformation.`;

    return {
        title,
        metaDescription: metaDescription.slice(0, 158),
        keywords: [
            profile.keyword,
            `${service.title} Malaysia`,
            'IT Services Malaysia',
            'Digital Transformation Malaysia',
            'Cloud Solutions Malaysia',
            'Software Development Malaysia',
            'Business Automation',
            'Enterprise Solutions',
        ],
        ogTitle: title,
        ogDescription: metaDescription.slice(0, 158),
        h1: service.title,
        heroIntro: `${COMPANY} delivers ${profile.keyword} for organizations in ${LOCATION} that need practical IT services, secure cloud solutions and measurable digital transformation. Our team focuses on ${profile.focus}, helping leaders modernize operations without unnecessary complexity.`,
        ctaLabel: 'Talk to an Expert',
        overview: `${service.title} helps businesses improve how technology supports daily operations, customer service and growth. ${COMPANY} approaches ${profile.keyword} with a practical mindset: understand the current environment, identify the highest-value improvements and build a solution that is secure, maintainable and ready to scale.`,
        services: profile.services,
        benefits: profile.benefits,
        process: profile.process,
        technologies: profile.technologies,
        industries,
        faqs: buildFaqs(service, profile),
        internalLinks: relatedFromSlugs(profile.related, allServices, service.slug),
        imageAlt: `${service.title} by ${COMPANY}`,
        imageTitle: `${service.title} services in ${LOCATION}`,
    };
};

export const applyServiceSeo = (services) => services.map((service) => ({
    ...service,
    seoContent: buildSeoContent(service, services),
}));
